import { Button } from '@components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@components/ui/dialog';
import { useRescheduler } from '@contexts/rescheduler';
import { useTranslation } from 'react-i18next';
import { RelatedSchedulesDialogItem } from './item';
import { FormRequired } from '@components/ui/form/required';
import { initialState } from '@contexts/rescheduler/constants';

export const RelatedSchedulesDialog = () => {
  const { open, relatedSchedules, setState } = useRescheduler();
  const { t } = useTranslation('app');

  const handleClose = () => setState(initialState);

  if (!relatedSchedules.length) return;

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="min-w-[600px]">
        <DialogHeader>
          <DialogTitle>{t('relatedSchedules.title')}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col">
          {relatedSchedules.map((el) => (
            <RelatedSchedulesDialogItem key={el.id} data={el} />
          ))}
        </div>
        <FormRequired />
        <div className="flex justify-end">
          <Button variant="ghost" onClick={handleClose}>
            {t('actions.close')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
